module.exports = {"demoData":{"demoPost":{"title":"Demo post","body":"this is a demo post","author":"Some author","tags":["tag1","tag2"],"category":"category1","selected":false,"state":"published"},"demoSettings":{"title":"Tamiat CMS","description":"Firebase & Vue.js based CMS"},"demoLogoLink":"https://raw.githubusercontent.com/tamiat/tamiat/master/tamiatlogo.png","demoNav":[{"name":"Home","path":"/"},{"name":"Admin","path":"/admin"},{"name":"google","path":"https://www.google.com","isAbsolute":true}]}}


//////////////////
// WEBPACK FOOTER
// ./tamiat.config.json
// module id = 6Yl0
// module chunks = 2